// extracted by mini-css-extract-plugin
module.exports = {"productDescription":"fallbackProductDescription_productDescription__x5PTQ"};